<div class="card-columns">
  <ng-container *ngFor="let column of menuColumns">
    <div class="column">
      <mat-card *ngFor="let item of filterMenus(column)">
        <mat-card-title>{{ item.mendtbshort | translate }}</mat-card-title>
        <mat-card-content>
          <mat-list>
            <ng-container *ngFor="let m of item.menu1">
              <mat-list-item *ngIf="m.mendialog"
                             style="cursor:pointer;"
                             (click)="openDialog(m.mencontroller)">
                <span>{{ m.mendtbshort | translate }}</span>
                <mat-divider></mat-divider>
              </mat-list-item>

              <mat-list-item *ngIf="!m.mendialog"
                             style="cursor:pointer;"
                             routerLinkActive="active"
                             [routerLink]="[m.mencontroller.toLowerCase()]">
                <span>{{ m.mendtbshort | translate }}</span>
                <mat-divider></mat-divider>
              </mat-list-item>
            </ng-container>
          </mat-list>
        </mat-card-content>
      </mat-card>
    </div>
  </ng-container>
</div>
